import React from "react";

export default function DayHeader({ day_name }) {
  function dayTypeStyle() {
    switch (day_name) {
      case "Today":
        return " today";
      case "Someday":
        return " someday yellow";
      default:
        return "";
    }
  }
  return (
    <div
      className={"day-name small-heading-txtstyl has-bubble" + dayTypeStyle()}
    >
      {day_name}
    </div>
  );
}
